document.addEventListener('DOMContentLoaded', function () {
  var sections = document.querySelectorAll('.cp-interactive-cards');
  if (!sections.length) return;

  // Only run this interactive behavior on pointer/hover devices (desktop/tablet with mouse)
  if (!window.matchMedia || !window.matchMedia('(hover: hover) and (pointer: fine)').matches) {
    return;
  }

  sections.forEach(function (section) {
    var list = section.querySelector('.cp-interactive-cards__list');
    if (!list) return;

    var cards = Array.prototype.slice.call(
      list.querySelectorAll('.cp-interactive-cards__card')
    );
    if (!cards.length) return;

    function setActiveCard(card) {
      cards.forEach(function (c) {
        c.classList.remove('cp-interactive-cards__card--initial-active');
      });
      if (card) {
        card.classList.add('cp-interactive-cards__card--initial-active');
      }
    }

    // Ensure first card is active on load if none is marked
    if (!list.querySelector('.cp-interactive-cards__card--initial-active') && cards[0]) {
      cards[0].classList.add('cp-interactive-cards__card--initial-active');
    }

    cards.forEach(function (card) {
      card.addEventListener('mouseenter', function () {
        setActiveCard(card);
      });

      card.addEventListener('focusin', function () {
        setActiveCard(card);
      });
    });
  });
});

